import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-2">
              <Link to="/" className="text-2xl font-heading font-bold text-background-50 whitespace-nowrap">
                韩漫大全
              </Link>
              <p className="mt-4 text-sm leading-relaxed text-background-50/60 max-w-sm">
                韩漫大全致力于为广大韩漫爱好者提供海量正版韩国漫画免费在线阅读服务。涵盖恋爱、悬疑、奇幻、校园等多种类型，每日更新最新章节。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">首页</Link>
                <Link to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">漫画分类</Link>
                <Link to="/comic/1" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">热门推荐</Link>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/category/romance" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">恋爱漫画</Link>
                <Link to="/category/thriller" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">悬疑漫画</Link>
                <Link to="/category/fantasy" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">奇幻漫画</Link>
                <Link to="/category/school" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">校园漫画</Link>
              </div>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {currentYear} 韩漫大全. All Rights Reserved.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">服务条款</a>
              <a href="#" className="text-xs text-background-50/40 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}